module.exports = __webpack_public_path__ + "img/tshirt-on-clothsline.9e215c2a.png";